import React, { useState, useEffect } from "react"
import { Container, Row, Col, Form } from "react-bootstrap"
import { navigate } from "gatsby"
import $ from "jquery"

import { PropertySearchUrl } from "@common/utils/property_utils"
import FilterMenu from "./FilterMenu"
import SearchType from "./Sections/SearchType"
import SearchArea from "./Sections/SearchArea"

import "./FilterBox.scss"

const {
  createResultsUrl,
} = require("../../../gatsby-library-common/PropertySearchNew")

const Filter = ({ propertySearch, searchState, pathName }) => {
  const {
    departmentVal,
    searchtypeVal,
    buildingval,
    minpriceVal,
    maxpriceVal,
    bedVal,
    areaVal,
    radiusVal,
  } = searchState

  // const [moreFilter, setMoreFilter] = useState(false)

  const srchtype =
    departmentVal === "commercial" || departmentVal === "residential"
      ? `${departmentVal}-${searchtypeVal}`
      : searchtypeVal

  const [showFilter, setShowFilter] = useState(false)
  const [srchTypeVal, setSrchTypeVal] = useState(searchtypeVal)
  const [srchTypeValSel, setSrchTypeValSel] = useState(srchtype)
  const [minPriceVal, setMinPriceVal] = useState(minpriceVal || "")
  const [maxPriceVal, setMaxPriceVal] = useState(maxpriceVal || "")
  const [bedroomVal, setBedroomVal] = useState(bedVal || "")
  const [propertyVal, setPropertyVal] = useState(buildingval || "")
  const [areaInputVal, setAreaInputVal] = useState(areaVal || "")
  const [showSuggestion, setShowSuggestion] = useState(true)
  const [milesVal, setMilesVal] = useState(radiusVal || "")

  useEffect(() => {
    if (areaVal !== areaInputVal) {
      setAreaInputVal(areaVal)
    }
  }, [areaVal])

  const priceOptions =
    searchtypeVal === "sales"
      ? propertySearch?.sales_price_list
      : propertySearch?.rent_price_list

  const resetFilters = () => {
    setMinPriceVal("")
    setMaxPriceVal("")
    setBedroomVal("")
    setPropertyVal("")
  }
  const handleSearchType = (val) => {
    const splitVal = val.split("-")
    setSrchTypeValSel(val)
    resetFilters()

    let path = ""

    // console.log("splitVal", splitVal)

    if (splitVal.length > 1) {
      setSrchTypeVal(splitVal[1])
      path = `${PropertySearchUrl(
        splitVal[0],
        splitVal[1],
      )}in-${areaVal.replace(/ /g, "-")}/`
    } else {
      setSrchTypeVal(val)
      const departSel = "residential"
      path = `${PropertySearchUrl(departSel, val)}in-${areaVal.replace(
        / /g,
        "-",
      )}/`
    }
    navigate(path)
  }

  const onFilterSubmit = (searchParams) => {
    // console.log("searchParams ==> 1", searchParams)
    const path = createResultsUrl(searchParams)
    navigate(path)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    // console.log("event", event)
    setShowSuggestion(false)
    setShowFilter(false)
    const splitArea = areaInputVal.split(",")

    const formFields = {
      ...searchState,
      areaVal: splitArea[0],
      departmentVal,
      bedVal: bedroomVal,
      minpriceVal: minPriceVal,
      maxpriceVal: maxPriceVal,
      buildingval: propertyVal,
      srchTypeVal,
      radiusVal: milesVal,
      bedValPlus: "true",
    }

    onFilterSubmit(formFields)
  }

  useEffect(() => {
    $(".select-option.dropdown").on("click", function () {
      $(".auto_suggest").addClass("d-none")
    })
  }, [])

  useEffect(() => {
    if (showFilter) {
      document.body.style.overflowY = "hidden"
    } else {
      document.body.style.overflowY = "auto"
    }
  }, [showFilter])

  // console.log("bedroomVal", bedroomVal)

  // console.log("searchState=>", searchState)

  return (
    <section className="filter">
      <Container>
        <Row>
          <Col>
            <Form onSubmit={handleSubmit}>
              <div className="filter-wrapper">
                <SearchType
                  selectOptions={propertySearch?.search_type}
                  searchTypeVal={srchTypeValSel}
                  handleChange={handleSearchType}
                  classNameWrapper="d-none d-xl-flex"
                />

                <div className="input-box">
                  <i className="icon icon-search" />
                  {/* <input type="text" placeholder="Enter your search location" /> */}
                  <SearchArea
                    areaVal={areaInputVal}
                    setAreaInputVal={setAreaInputVal}
                    setShowSuggestion={setShowSuggestion}
                    showSuggestion={showSuggestion}
                  />
                </div>

                <FilterMenu
                  showFilter={showFilter}
                  propertySearch={propertySearch}
                  srchTypeVal={srchTypeVal}
                  handleSearchType={handleSearchType}
                  priceOptions={priceOptions}
                  minPriceVal={minPriceVal}
                  maxPriceVal={maxPriceVal}
                  setMinPriceVal={setMinPriceVal}
                  setMaxPriceVal={setMaxPriceVal}
                  bedroomVal={bedroomVal}
                  setBedroomVal={setBedroomVal}
                  propertyVal={propertyVal}
                  setPropertyVal={setPropertyVal}
                  srchTypeValSel={srchTypeValSel}
                  pathName={pathName}
                  setShowFilter={setShowFilter}
                  areaVal={areaInputVal}
                  setAreaInputVal={setAreaInputVal}
                  setShowSuggestion={setShowSuggestion}
                  showSuggestion={showSuggestion}
                  filterType="search_result"
                  milesVal={milesVal}
                  setMilesVal={setMilesVal}
                  departmentVal={departmentVal}
                />

                <button
                  className="filter-btn button button-outline d-xl-none"
                  onClick={() => setShowFilter(!showFilter)}
                  type="button"
                >
                  <i className="icon icon-filter" /> Filters
                </button>

                <button className="search-btn" type="submit">
                  Search
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
export default Filter
